import { isEmpty, remove } from 'lodash';

/**
 * # swList
 * A component to list items. Allows you to add and remove items from the list.
 */
angular.module('coreModule').directive('swList', ($log) => ({
  template: require('../../views/sw-list.html').default,
  restrict: 'E',
  controllerAs: '$ctrl',
  bindToController: true,
  transclude: true,

  scope: {
    itemModel: '=',
    list: '=',
    onRemove: '@',
    onAdd: '@',
  },

  controller: [
    '$scope',
    function swListController(scope) {
      const $ctrl = this;

      this.isListEmpty = () => isEmpty($ctrl.list);

      this.addItem = () => {
        if (angular.isObject($ctrl.itemModel) && angular.isArray($ctrl.list)) {
          $ctrl.list.push($ctrl.itemModel);
          scope.$parent.$eval($ctrl.onAdd);
        } else {
          $log.error('Data model is not an Object or list is not defined!');
        }
      };

      this.removeItem = (item) => {
        remove($ctrl.list, item);
        scope.$parent.$eval($ctrl.onRemove);
      };
    },
  ],
}));
